import { format } from 'date-fns';
export function getValidityDateLabel(validFor, getTranslation) {
    var _a, _b, _c;
    let dateLabel = '';
    if (validFor) {
        const formattedStartDate = format(validFor.startDate, 'DD/MM');
        if (validFor.endDate) {
            const formattedEndDate = format(validFor.endDate, 'DD/MM');
            dateLabel = `${(_a = getTranslation('bills.common.date.from')) !== null && _a !== void 0 ? _a : ''} ${formattedStartDate} ${(_b = getTranslation('bills.common.date.to')) !== null && _b !== void 0 ? _b : ''} ${formattedEndDate}`;
        }
        else {
            dateLabel = `${(_c = getTranslation('bills.category.OnDate')) !== null && _c !== void 0 ? _c : ''} ${formattedStartDate}`;
        }
    }
    return dateLabel;
}
